// extracted by mini-css-extract-plugin
export var box = "Slide-module--box--e684c";
export var box_md = "Slide-module--box_md--729ba";
export var box_xmd = "Slide-module--box_xmd--b7cf1";
export var box_flex = "Slide-module--box_flex--a2dd1";
export var box_lg = "Slide-module--box_lg--fa452";
export var box_sm = "Slide-module--box_sm--bd706";
export var box_outer = "Slide-module--box_outer--96d3e";
export var box_whiteBg = "Slide-module--box_white-bg--a439a";
export var box_noMarginBottom = "Slide-module--box_no-margin-bottom--5a35f";
export var box_noPadding = "Slide-module--box_no-padding--5948d";
export var box_outerGray = "Slide-module--box_outer-gray--38502";
export var box_dark = "Slide-module--box_dark--712ae";
export var box_zIndex = "Slide-module--box_z-index--96696";
export var box_zIndex6 = "Slide-module--box_z-index-6--c67b6";
export var box_eventsWithLine = "Slide-module--box_events-with-line--8e114";
export var box_featuresAo = "Slide-module--box_features-ao--ac4ee";
export var box_verticalPaddings = "Slide-module--box_vertical-paddings--82e50";
export var clearP = "Slide-module--clearP--05f6d";
export var clearP_vc = "Slide-module--clearP_vc--3376d";
export var slide = "Slide-module--slide--91de5";
export var pictureWrapper = "Slide-module--pictureWrapper--8cb95";
export var picture = "Slide-module--picture--adbb9";
export var img = "Slide-module--img--891b6";
export var text = "Slide-module--text--f7864";
export var link = "Slide-module--link--388f3";
export var linkText = "Slide-module--linkText--acf26";
export var icon = "Slide-module--icon--2d8d3";
export var position = "Slide-module--position--47d05";
export var description = "Slide-module--description--ad5cf";
export var fadeInAnimation = "Slide-module--fadeInAnimation--016ec";
export var placeHolderShimmer = "Slide-module--placeHolderShimmer--c2442";